import Vue from "vue";
import Router from "vue-router";
import auth from "@/commons/authService";
import commonFn from "@/commons/commonFunction";
import popupUtil from "@/commons/popupUtil";
import i18n from "@/i18ns/i18n";
import messageBox from "@/commons/messageBox";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: '/',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "",
      redirect: '/tracuu',
      component: () => import("@/layouts/MainLayout.vue"),
      meta: {
        // anonymous: true
      },
      children: [
        {
          path: "/tracuu",
          name: "Search",
          component: () =>
            import(
              /*webpackChunkName:'demo'*/
              "@/views/Search/Search.vue"
            ),
          meta: {
            anonymous: true
          }
        },
      ]
    },
    {
      path: "/500",
      name: "500",
      component: () =>
        import(
          /*webpackChunkName:'pages'*/
          "@/pages/404.vue"
        ),
      meta: {
        anonymous: true
      }
    },
    {
      // Redirect to 404 page, if no match found
      path: "/dev-login",
      component: () =>
        import(
          /*webpackChunkName:'pages'*/
          "@/pages/DevLogin.vue"
        ),
      meta: {
        anonymous: true
      }
    },
    {
      // Redirect to 404 page, if no match found
      path: "*",
      component: () =>
        import(
          /*webpackChunkName:'pages'*/
          "@/pages/404.vue"
        ),
      meta: {
        anonymous: true
      }
    }
  ]
});

let routerOnReady = function() {};

let routerOnError = function(error) {
  // commonFunc.errorLogging(error);
};

router.onError(error => {
  const pattern = /Loading chunk (\S)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  if (isChunkLoadFailed && window._appConfig.showLoadChunkFail) {
    messageBox.showError(i18n.t("i18nSY.LoadChuckFail")).then(res => {
      window.location.reload();
    });
  }
});

router.onReady(routerOnReady, routerOnError);

router.afterEach(() => {
  commonFn.unmask();
});

router.beforeEach((to, from, next) => {
  //hide all popup
  popupUtil.hideAll();

  if (to.meta.anonymous) {
    //bypass check authentication
    next();
  } else if (!auth.isAuthenticated()) {
    //check authentication
    // gọi đến dc client là pass kiểm tra ở server về authe cookie của amis rồi -> gọi request sinh authen token
    commonFn.mask();
    auth
      .getToken()
      .then(() => {
        next();
      })
      .catch(err => {
        let msg = err.message;
        if (err.response) {
          switch (err.response.status) {
            case 404:
              return;
            case 403:
              //không có quyền vào ứng dụng
              next({
                name: "403"
              });
              return;
          }
        }
        next({
          name: "500",
          params: { error: msg }
        });
      })
      .finally(() => {
        commonFn.unmask();
      });
  } else {
    //xử lý load resource trước rồi mới chuyển router
    // loadLanguageAsync(next);
    next();
  }
});

const loadedLanguages = {
  vi: true
}; // our default language that is preloaded

function loadLanguageAsync(callback) {
  const lz = i18n,
    lang = lz.locale;

  let loaded = loadedLanguages[lang];
  if (loaded) {
    callback();
    return;
  }

  commonFn.mask();
  resourceAPI
    .pull(lang)
    .then(res => {
      let rs = {};
      for (let i in res) {
        rs[i] = JSON.parse(res[i]);
      }

      loadedLanguages[lang] = true;
      lz.mergeLocaleMessage(lang, rs);
    })
    .catch(err => {
      console.error(err);
    })
    .finally(() => {
      commonFn.unmask();
      callback();
    });
}

export default router;
